const FatalErrorTypeEnum = Object.freeze({
    REGISTRATION: 'REGISTRATION',
    REGISTRATION_SETUP: 'REGISTRATION_SETUP',
    RECATEGORISATION: 'RECATEGORISATION',
    SUSPENDED: 'SUSPENDED'
});

export default FatalErrorTypeEnum;
